// Navigation only: the destination still requires normal server authorization.
export function loginReturnPath(current: string, saved: string | null): string {
  for (const candidate of [current, saved]) {
    if (!candidate || !candidate.startsWith('/') || candidate.startsWith('//') ||
        /[\\\u0000-\u0020\u007f]/.test(candidate)) continue;
    const url = new URL(candidate, 'https://boltos.invalid');
    if (url.origin !== 'https://boltos.invalid' || url.pathname === '/login' ||
        url.pathname.startsWith('/api/')) continue;
    return url.pathname + url.search + url.hash;
  }
  return '/';
}
